import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TabItem, TTabsListItem } from '@/components/TabsList/types'
import { Link } from 'react-router-dom'

interface TabsListProps {
  list: TTabsListItem[]
  activeTab: TabItem
}

export const TabsList: FC<TabsListProps> = ({ list, activeTab }) => {
  const { t } = useTranslation()

  return (
    <ul className="flex mt-8 rounded-[44px] p-1 bg-[rgba(0,0,0,0.03)]">
      {list.map((item) => (
        <li
          key={item.value}
          className={`flex-1 rounded-[44px] py-[9px] px-2 transition duration-300 text-center font-medium text-base ${item.link.includes(activeTab) ? 'bg-white text-green4' : 'text-secondary'}`}
        >
          <Link to={item.link}>{t(item.label as any)}</Link>
        </li>
      ))}
    </ul>
  )
}
